
export const waitForMetaPixelInitAndTrack = (trackingType) => {
  if (window.fbq != undefined) {
    fbq('track', trackingType);
    console.debug(`Tracked ${trackingType}`);
  } else {
    setTimeout(waitForMetaPixelInitAndTrack, 10);
  }
};
